import { DOCUMENT } from '@angular/common';
import { AfterViewInit, Component, Inject } from '@angular/core';
import { UtilService } from '@services/util.service';
import { RequisicaoExternaService } from '../../services/requisicaoexterna.service';

@Component({
  selector: 'app-meteorologia',
  templateUrl: './meteorologia.component.html',
  styleUrls: ['./meteorologia.component.css'],
})

export class MeteorologiaComponent implements AfterViewInit {
  utilService: UtilService;
  constructor(private requisicaoExternaService: RequisicaoExternaService, @Inject(DOCUMENT) public document: Document) {
  }

  ngAfterViewInit(): void {
    this.functionAtualizarRelatorioTomus();
  }

  functionAtualizarRelatorioTomus = () => {
    this.requisicaoExternaService.ObterResultado("meteorologia").subscribe(resultado => {
      var referenciaElementoTestado = this.document.getElementById("iframeMeteorologia") as HTMLIFrameElement;
      var parteToken = resultado.resultadoRequisicao.split(' ');
      referenciaElementoTestado.src = 'https://smsub.tiindustrial.com.br/login?page=monitoring-meteorological-zone-table&token=' + parteToken[1];
    });
  }
}
